const config = {} as any;

config.tealium = {};
config.tealium.account = process.env.GATSBY_TEALIUM_ACCOUNT || '';
config.tealium.profile = process.env.GATSBY_TEALIUM_PROFILE || '';
config.tealium.environment = process.env.GATSBY_TEALIUM_ENVIRONMENT || '';

export const tealiumConfig = config.tealium;
export default config;
